import { render } from "./PantryIngredientCameraListView.vue?vue&type=template&id=4858cd36&ts=true"
import script from "./PantryIngredientCameraListView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientCameraListView.vue?vue&type=script&lang=ts"

import "./PantryIngredientCameraListView.vue?vue&type=style&index=0&id=4858cd36&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__